<h1 mat-dialog-title>
    {{data.title}}
    <button mat-button [mat-dialog-close]="true" tabindex="1">X</button>
  </h1>
  <div mat-dialog-content>
    <p [innerHTML]="data.message | sanitizeHtml"></p>
  </div>